var windowHeight = $(window).height();
$('.l-header-main').css('height', windowHeight);
$('.l-header-contact').css('height', windowHeight);
$('.l-header-bg').css('height', windowHeight);
$('.top-hero').css('height', windowHeight);

$(window).resize(function () {
  var windowHeight = $(window).height();
  $('.l-header-main').css('height', windowHeight);
  $('.l-header-contact').css('height', windowHeight);
  $('.l-header-bg').css('height', windowHeight);
  $('.top-hero').css('height', windowHeight);
});